import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MessagesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
`;

export const RowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  border-radius: 4px;
  border: ${theme.colors.border} 1px solid;
  padding: 4px;
  align-items: center;
`;

export const PromptWrapper = styled.div`
  width: 75%;
`;

const BaseAssistantMessageWrapper = styled.div`
  gap: 4px;
  border-radius: 4px;
  border: ${theme.colors.border} 1px solid;
  padding: 4px;
  display: flex;
  flex-direction: column;
`;

export const ErrorWraper = styled(BaseAssistantMessageWrapper)`
  border-color: red;
`;

export const UserPromptWraper = styled(RowWrapper)`
  border-color: ${theme.colors.blue500};
`;

export const AssistantResponseWrapper = styled(BaseAssistantMessageWrapper)`
  border-color: ${theme.colors.blue900};
  display: flex;
  flex-direction: column;
`;

export const MessageTextWraper = styled.div`
  word-wrap: break-word;
`;
